(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["empowering-partners"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Simple slider implementation
    const sliders = document.querySelectorAll('.empowering-partners__slider');
    
    sliders.forEach(function(slider) {
      const slides = slider.querySelectorAll('.empowering-partners__slide');
      const dots = document.querySelectorAll('.empowering-partners__dot');
      let currentIndex = 0;
      
      // Function to show a specific slide
      function showSlide(index) {
        // Validate index
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        
        // Hide all slides
        slides.forEach(function(slide) {
          slide.classList.remove('active');
          slide.setAttribute('aria-hidden', 'true');
        });
        
        // Remove active state from all dots
        dots.forEach(function(dot) {
          dot.classList.remove('active');
          dot.setAttribute('aria-current', 'false');
        });
        
        // Show the selected slide
        slides[index].classList.add('active');
        slides[index].setAttribute('aria-hidden', 'false');
        
        // Activate the corresponding dot
        if (dots[index]) {
          dots[index].classList.add('active');
          dots[index].setAttribute('aria-current', 'true');
        }
        
        currentIndex = index;
      }
      
      // Add click event listeners to all dots
      dots.forEach(function(dot, index) {
        dot.addEventListener('click', function() {
          console.log('Dot clicked:', index);
          showSlide(index);
        });
      });
      
      // Add video play functionality
      const playButtons = slider.querySelectorAll('.empowering-partners__play-button');
      playButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          const slide = e.currentTarget.closest('.empowering-partners__slide');
          const videoUrl = slide.getAttribute('data-video-url');
          
          if (videoUrl && videoUrl.trim() !== '') {
            // Create and show video modal
            createVideoModal(videoUrl);
          } else {
            console.error('No video URL provided');
          }
        });
      });
      
      // Function to create video modal
      function createVideoModal(videoUrl) {
        const modal = document.createElement('div');
        modal.classList.add('empowering-partners__video-modal');
        
        // Create iframe for video
        let videoHtml = '';
        
        if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
          // YouTube embed
          const youtubeId = getYoutubeId(videoUrl);
          videoHtml = `<iframe src="https://www.youtube.com/embed/${youtubeId}?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
        } else if (videoUrl.includes('vimeo.com')) {
          // Vimeo embed
          const vimeoId = getVimeoId(videoUrl);
          videoHtml = `<iframe src="https://player.vimeo.com/video/${vimeoId}?autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
        } else {
          // Regular video
          videoHtml = `<video controls autoplay><source src="${videoUrl}" type="video/mp4"></video>`;
        }
        
        // Create modal content
        modal.innerHTML = `
          <div class="empowering-partners__video-modal-content">
            <button class="empowering-partners__video-modal-close" aria-label="Close video">&times;</button>
            <div class="empowering-partners__video-container">
              ${videoHtml}
            </div>
          </div>
        `;
        
        // Add to body
        document.body.appendChild(modal);
        document.body.classList.add('empowering-partners__modal-open');
        
        // Add close functionality
        const closeButton = modal.querySelector('.empowering-partners__video-modal-close');
        closeButton.addEventListener('click', function() {
          document.body.removeChild(modal);
          document.body.classList.remove('empowering-partners__modal-open');
        });
        
        // Close on click outside
        modal.addEventListener('click', function(e) {
          if (e.target === modal) {
            document.body.removeChild(modal);
            document.body.classList.remove('empowering-partners__modal-open');
          }
        });
      }
      
      // Helper function to get YouTube video ID
      function getYoutubeId(url) {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[7].length === 11) ? match[7] : '';
      }
      
      // Helper function to get Vimeo video ID
      function getVimeoId(url) {
        const regExp = /vimeo\.com\/(?:.*?)\/(?:.*?)\/(?:.*?)\/([0-9]+)|vimeo\.com\/([0-9]+)/;
        const match = url.match(regExp);
        return match ? (match[1] || match[2]) : '';
      }
      
      // Initialize auto-slide if enabled
      const autoSlideInterval = parseInt(slider.getAttribute('data-auto-slide'), 10) || 0;
      let autoSlideTimer = null;
      
      function startAutoSlide() {
        if (autoSlideInterval > 0 && !autoSlideTimer) {
          autoSlideTimer = setInterval(function() {
            showSlide(currentIndex + 1);
          }, autoSlideInterval);
        }
      }
      
      function stopAutoSlide() {
        if (autoSlideTimer) {
          clearInterval(autoSlideTimer);
          autoSlideTimer = null;
        }
      }
      
      // Start auto-slide
      startAutoSlide();
      
      // Pause on hover
      slider.addEventListener('mouseenter', stopAutoSlide);
      slider.addEventListener('mouseleave', startAutoSlide);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
